import React from 'react';
import styled from 'styled-components';
import * as _ from 'underscore';
import * as d3 from 'd3';
import $ from "jquery";
import { AnnotationLabel , AnnotationBracket , AnnotationCallout } from 'react-annotation';
import '../stylesheets/PercentageChart.css';

import {colorLookup,colorLookupSDG} from '../utils/colorHash';
const color = colorLookup;
const sdg_color = colorLookupSDG;

const Wrapper = styled.div`
  width: 100%;
`
const ChartContainer = styled.div`
  width: 90%;
  position: relative;
  top: 125px;
  left: 5%;
  height: 230px;
  margin-bottom: 60px;
`
const QuestionTitle = styled.p`
  font-family: 'Roboto';
  font-weight: 600;
  font-size: 18px;
  color: white;
  left: 5%;
  position: relative;
  display: inline-block;
  top: 110px;
  width: 90%;
`
const LegendContainer = styled.div`
  width: 90%;
  left: 5%;
  position: relative;
  top: 80px;
  &>ul{
    list-style-type: none;
    padding-left: 0px;
  }
  &>ul>li{
    line-height: 1.3;
    font-size: 36px;
    transition: all 400ms;
  }
  &>ul>li>span:hover{
    opacity: .7;
  }
  &>ul > li > span {
    cursor: pointer;
    color: white;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    position: relative;
    top: -7px;
    transition: all 400ms;
  }
`
const Tag = styled.em`
  opacity: 1 !important;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  padding: 2px 5px;
  margin-left: 10px;
  border-radius: 3px;
  color: white;
  background: ${props => props.color};
`

export default class PercentageChart extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      vizData: null,
      optionMap: null,
      annotationItems: [],
      hoverAnnotationItem: null
    }
    this.currentSelectedItem = props.currentSelectedItem;
    this.data = props.data;
    this.list = props.list;

    this.calculateChart = this.calculateChart.bind(this);
    this.setHoverState = this.setHoverState.bind(this);
    this.legendGenerator = this.legendGenerator.bind(this);

  }

  componentDidMount(){
    this.calculateChart();
  }

  componentWillReceiveProps(nextProps){
    this.currentSelectedItem = nextProps.currentSelectedItem;
    this.data = nextProps.data;
    this.list = nextProps.list;
    this.calculateChart();
  }

  calculateChart(){

    if(!this.data || !this.list) return;


    d3.select(this.chartContainer).select('svg').select('.graphLayer').selectAll('*').remove();

    const margin = {top: 20, right: 50, bottom: 20, left: 0};
    const width = $(this.chartContainer).width() - margin.left - margin.right;
    const height = $(this.chartContainer).height() - margin.top - margin.bottom;

    d3.select(this.chartContainer).select('svg').select('.annotaionLayer')
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.g = d3.select(this.chartContainer).select('svg')
      .attr('overflow',"visible")
      .attr('width',width+ margin.left + margin.right +'px')
      .attr('height',height + margin.top + margin.bottom+'px')
      .select('.graphLayer')
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var totalRecords = 0;
    const currentSelectedKey = this.list[this.currentSelectedItem]['key'][0];
    const optionMap = this.list[this.currentSelectedItem]['optionMap'];
    const options = Object.keys(optionMap);
    const vizData = this.data.reduce((a, d) => {
      let i = d[currentSelectedKey];

      if(typeof i === 'number' && options.includes(i.toString()) ) {
        a[i]++;
        totalRecords++;
      }
      else if (typeof i === 'string'){
        totalRecords++;
        i.split(',').forEach(_d =>{
          if(_d != "" && options.includes(_d) ){
            a[+_d]++
          }
        })
      }
      return a;
    },options.reduce((o, key) => ({ ...o, [key]: 0}), {}));
    const xScale = d3.scaleLinear().domain([0,totalRecords]).range([0,width]);
    const yScale = this.list[this.currentSelectedItem]['multiselect']
      ? d3.scaleBand().domain(options).rangeRound([0,height]).padding([.35])
      : d3.scaleBand().domain(['2018']).rangeRound([height,0]).padding([.5]);

    const stack = d3.stack().keys(options.reverse())
    // .order(d3.stackOrderDescending);
    var stackedSeries = stack([vizData]);

    this.breakdownByCategory = this.list[this.currentSelectedItem]['multiselect']
      ? this.g.selectAll('rect').data((() =>{const out = [];Object.keys(vizData).forEach(d =>{out.push({key:d,value: vizData[d]})}); return out;})())
        .enter().append("rect")
        .attr("fill",_d => {
          if(this.list[this.currentSelectedItem]['SDGColor']){
            return sdg_color(+_d.key);
          }
          return color(_d.key)
        })
        .attr("y",d=> yScale(d.key))
        .attr("x",0 )
        .attr("height",yScale.bandwidth())
        .attr("key", d => d.key)

      : this.g.selectAll("g.series").data(stackedSeries)
        .enter().append("g")
        .attr("class","series")
        .attr("key", d => d.key)
        .attr("fill",(d,i) => {
          if(this.list[this.currentSelectedItem]['SDGColor']){
            return sdg_color(+d.key);
          }
          return color(d.key);
        })
        .selectAll("rect")
        .data(d=>d)
        .enter().append("rect")
        .attr("y",d=> 0)
        .attr("x",d=> xScale(d[0]) )
        .attr("height",yScale.bandwidth())


    if(!this.list[this.currentSelectedItem]['multiselect']){
      this.breakdownByCategory
        .attr("width",0)
        .transition()
        .duration(1400)
        .attr("width",d=> xScale(d[1]) - xScale(d[0]))
        .on('end',() =>{

          // annotation
          this.breakdownByCategory.call(g =>{
            const setHoverState = this.setHoverState; // use with in onClick, d3 legacy
            const keysSorted = Object.keys(vizData).sort(function(a,b){return vizData[a]-vizData[b]}).reverse();
            const annotationArr = [];

            g.each(function(d){
              const width = +d3.select(this).attr('width');
              const x = +d3.select(this).attr('x');
              const y = 40;
              const count = d.data[stackedSeries[annotationArr.length].key];
              const key = d3.select(this.parentNode).attr('key');
              const description = optionMap[key];
              const JSX = (<AnnotationCallout
                key={key}
                x={x + width/2}
                y={y}
                dy={y-10}
                dx={0}
                color={"white"}
                editMode={false}
                note={{
                  "title": description,
                  label: count+ ' / '+ totalRecords,
                  align: 'middle',
                  "lineType": "horizontal"
                 }}/>)

              annotationArr.push(JSX)

              d3.select(this)
              .on('mouseover',function(){
                setHoverState(_.find(annotationArr,(d) => d.key === d3.select(this.parentNode).attr('key')) );
              })
              .on('mouseout',function(){
                setHoverState(null);
              })
            }) // g.each
            this.setState({annotationItems: annotationArr });
          });
        })
    }
    else {
      this.breakdownByCategory
        .attr("width",0)
        .transition()
        .duration(1400)
        .attr("width",d=> xScale(d.value) )
        .on('end',() =>{

          // annotation
          this.breakdownByCategory.call(rect =>{
            const setHoverState = this.setHoverState; // use with in onClick, d3 legacy
            const keysSorted = Object.keys(vizData).sort(function(a,b){return vizData[a]-vizData[b]}).reverse();
            const annotationArr = [];

            rect.each(function(d){


              const key = d3.select(this).attr('key');
              const width = +d3.select(this).attr('width');
              const height = +d3.select(this).attr('height');
              const x = +d3.select(this).attr('x');
              const y = +d3.select(this).attr('y');
              const count = d.value;
              const description = optionMap[d.key];
              const JSX = (<AnnotationBracket
                key={d.key}
                x={x + width}
                y={y}
                dy={0}
                dx={0}
                color={"#ffffff00"}
                editMode={false}
                subject={{"height":height,"type":"square"}}
                note={{
                  title: description,
                  label: count+ ' / '+ totalRecords,
                  labelColor: '#122035',
                  titleColor: '#122035',
                  wrap:300,
                 }}
              />)
              annotationArr.push(JSX)

              d3.select(this)
              .on('mouseover',function(){
                setHoverState(_.find(annotationArr,(d) => d.key === d3.select(this).attr('key')) );
                d3.select('.annotation-subject').append('rect')
                  .attr('width','300')
                  .attr('height','60')
                  .attr('transform','translate(20,-20)')
                  .attr('fill','white')
                  .attr('ry','5px')
                  .attr('rx','5px')

              })
              .on('mouseout',function(){
                setHoverState(null);
              })
            }) // rect.each
            this.setState({annotationItems: annotationArr });
          });
        })
    }

    this.setState({vizData: vizData, optionMap: optionMap});
  }

  setHoverState(elem){
    this.setState({hoverAnnotationItem: elem});
  }

  legendGenerator(){
    if(this.state.optionMap && this.state.vizData){
      return <ul>{ Object.keys(this.state.vizData).map(i => (
          <li
          key={i}
          onMouseOver={() => {
            this.setHoverState(_.find(this.state.annotationItems,(d) => d.key == i));
            window.setTimeout(() =>{
              if(!this.list[this.currentSelectedItem]['multiselect']) return;
              d3.select('.annotation-subject').append('rect')
                .attr('width','300')
                .attr('height','60')
                .attr('transform','translate(20,-20)')
                .attr('fill','white')
                .attr('ry','5px')
                .attr('rx','5px')
            },1)
          }}
          onMouseOut={() => this.setHoverState(null)}>
            <span>{ parseFloat( (this.state.vizData[i] / this.data.length) * 100).toFixed(1) + '% of company participants selected '}
              <Tag color={() =>{
                if(this.list[this.currentSelectedItem]['SDGColor']){
                  return sdg_color(i);
                }
                return color(i);
              }}>
                {this.state.optionMap[i]}
              </Tag>
            </span>
          </li>)) }
        </ul>
    }
  }

  render(){
    return(
      <Wrapper>
        <QuestionTitle>{this.list && this.list[this.currentSelectedItem].description}</QuestionTitle>
        <ChartContainer innerRef={(chartContainer) => {return this.chartContainer = chartContainer }}>
          <svg>
            <g className="graphLayer"/>
            <g className="annotaionLayer">
              {this.state.hoverAnnotationItem && this.state.hoverAnnotationItem}
            </g>
          </svg>
        </ChartContainer>
        <LegendContainer>
          {this.legendGenerator()}
        </LegendContainer>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/PercentageChart.js